<!-- StyledInput.vue -->
<template>
    <div class="input-group">
      <label :for="id" class="input-label">{{ label }}:</label>
      <input
        :id="id"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        class="styled-input"
        :type="type"
        :placeholder="placeholder"
      />
    </div>
  </template>
  
  <script>
  export default {
    name: 'StyledInput',
    props: {
      label: {
        type: String,
        required: true
      },
      modelValue: {
        type: [String, Number],
        default: ''
      },
      id: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'text'
      },
      placeholder: {
        type: String,
        default: ''
      }
    },
    emits: ['update:modelValue']
  };
  </script>
  
  <style scoped>
  .input-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
  }
  
  .input-label {
    font-size: 1rem;
    font-weight: 400;
    color: #545051;
    margin-bottom: 4px;
  }
  
  .styled-input {
    font-size: 1rem;
    font-weight: 400;
    color: #545051;
    border: none;
    border-bottom: 1px solid #545051;
    background: transparent;
    padding: 4px 0;
    outline: none;
  }
  
  .styled-input:focus {
    border-bottom: 2px solid #545051;
  }

  @media (max-width: 1024px) {
  .input-group {
    width: 75%;
  }
  
  .styled-input {
    width: 100%; /* Keep input full width of its container */
  }
  }

  </style>